
import snail_head from "@/assets/images/active/snail/fifth/mo/snail_head.png";
import earth_head from "@/assets/images/active/snail/fifth/mo/earth_head.png";
import forg_head from "@/assets/images/active/snail/fifth/mo/forg_head.png";
import brid_head from "@/assets/images/active/snail/fifth/mo/brid_head.png";
import msg_1 from "@/assets/images/active/snail/fifth/mo/msg_1.png";
import msg_2 from "@/assets/images/active/snail/fifth/mo/msg_2.png";
import msg_3 from "@/assets/images/active/snail/fifth/mo/msg_3.png";
import msg_5 from "@/assets/images/active/snail/fifth/mo/msg_5.png";
import msg_6 from "@/assets/images/active/snail/fifth/mo/msg_6.png";
import msg_7 from "@/assets/images/active/snail/fifth/mo/msg_7.png";
import msg_4 from "@/assets/images/active/snail/fifth/mo/msg_4.png";


export class TrialConfig {

    // 多语言模板
    static TRANSLATIONS = {
        'zh-cn': {
            captions: `在逃多年的<span>英雄</span>罪犯蜗牛与黄鹂鸟落网，直播公审即将开启！在逃多年的<span>英雄</span>罪犯蜗牛与黄鹂鸟落网，直播公审即将开启！ 在逃多年的<span>英雄</span>罪犯蜗牛与黄鹂鸟落网，直播公审即将开启！`,
            watch_btn: require('@/assets/images/active/snail/fifth/mo/zh/btn_1.png'),
            slogan: require('@/assets/images/active/snail/fifth/mo/zh/slogan.png'),
            open_btn: require('@/assets/images/active/snail/fifth/mo/zh/open_btn.png'),
            details: require('@/assets/images/active/snail/fifth/mo/zh/details.png'),
            brid_details: require('@/assets/images/active/snail/fifth/mo/zh/brid_details.png'),
            dna: require('@/assets/images/active/snail/fifth/mo/zh/dna.png'),
            self: require('@/assets/images/active/snail/fifth/mo/zh/self.png'),
            brid_self: require('@/assets/images/active/snail/fifth/mo/zh/brid_self.png'),
            native: require('@/assets/images/active/snail/fifth/mo/zh/native.png'),
            brid_native: require('@/assets/images/active/snail/fifth/mo/zh/brid_native.png'),
            union: require('@/assets/images/active/snail/fifth/mo/zh/union.png'),
            envelope: require('@/assets/images/active/snail/fifth/mo/zh/envelope.png'),
            device: require('@/assets/images/active/snail/fifth/mo/zh/device.png'),
            evidence: require('@/assets/images/active/snail/fifth/mo/zh/evidence.png'),
            evidence1: require('@/assets/images/active/snail/fifth/mo/zh/evidence1.png'),
            evidence2: require('@/assets/images/active/snail/fifth/mo/zh/evidence2.png'),
            evidence3: require('@/assets/images/active/snail/fifth/mo/zh/evidence3.png'),
            evidence4: require('@/assets/images/active/snail/fifth/mo/zh/evidence4.png'),
            evidence5: require('@/assets/images/active/snail/fifth/mo/zh/evidence5.png'),
            evidence6: require('@/assets/images/active/snail/fifth/mo/zh/evidence6.png'),
            rule: require('@/assets/images/active/snail/fifth/mo/zh/rule.png'),
            criminal: require('@/assets/images/active/snail/fifth/mo/zh/criminal.png'),
            criminal1: require('@/assets/images/active/snail/fifth/mo/zh/1.png'),
            criminal2: require('@/assets/images/active/snail/fifth/mo/zh/2.png'),
            criminal3: require('@/assets/images/active/snail/fifth/mo/zh/3.png'),
            criminal4: require('@/assets/images/active/snail/fifth/mo/zh/4.png'),
            criminal5: require('@/assets/images/active/snail/fifth/mo/zh/5.png'),
            criminal6: require('@/assets/images/active/snail/fifth/mo/zh/6.png'),
            criminal7: require('@/assets/images/active/snail/fifth/mo/zh/7.png'),
            criminal8: require('@/assets/images/active/snail/fifth/mo/zh/8.png'),
            testimony1: require('@/assets/images/active/snail/fifth/mo/zh/testimony1.png'),
            testimony2: require('@/assets/images/active/snail/fifth/mo/zh/testimony2.png'),
            testimony3: require('@/assets/images/active/snail/fifth/mo/zh/testimony3.png'),
            testimony4: require('@/assets/images/active/snail/fifth/mo/zh/testimony4.png'),
            testimony5: require('@/assets/images/active/snail/fifth/mo/zh/testimony5.png'),
            testimony6: require('@/assets/images/active/snail/fifth/mo/zh/testimony6.png'),
            testimony7: require('@/assets/images/active/snail/fifth/mo/zh/testimony7.png'),
            testimony8: require('@/assets/images/active/snail/fifth/mo/zh/testimony8.png'),
            wanted: require('@/assets/images/active/snail/fifth/mo/zh/wanted.png'),
            wantedLow: require('@/assets/images/active/snail/fifth/mo/zh/wantedLow.png'),
            event: require('@/assets/images/active/snail/fifth/mo/zh/event.png'),
            eventLow: require('@/assets/images/active/snail/fifth/mo/zh/eventLow.png'),
            again: require('@/assets/images/active/snail/fifth/mo/zh/again.png'),
            share: require('@/assets/images/active/snail/fifth/mo/zh/share.png'),
            shareLow: require('@/assets/images/active/snail/fifth/mo/zh/wantedLow.png'),
            code: require('@/assets/images/active/snail/fifth/mo/zh/code.png'),
            reward_title: require('@/assets/images/active/snail/fifth/mo/zh/reward_title.png'),
            click: require('@/assets/images/active/snail/fifth/mo/zh/click.png'),
            reward1: require('@/assets/images/active/snail/fifth/mo/zh/reward1.png'),
            reward2: require('@/assets/images/active/snail/fifth/mo/zh/reward2.png'),
            reward3: require('@/assets/images/active/snail/fifth/mo/zh/reward3.png'),
            last_msg: require('@/assets/images/active/snail/fifth/mo/zh/last_msg.png'),
            snail: require('@/assets/images/active/snail/fifth/mo/post_snail.png'),
            brid: require('@/assets/images/active/snail/fifth/mo/post_brid.png'),
            race1: require('@/assets/images/active/snail/fifth/mo/zh/race1.png'),
            race2: require('@/assets/images/active/snail/fifth/mo/zh/race2.png'),
            stamp: require('@/assets/images/active/snail/fifth/mo/zh/stamp.png'),
            isLogin: '很抱歉，请先登录',
            isRole: '很抱歉，请先选择角色',
            copySuccess: '已成功复制分享链接',
            copyError: '复制失败',
            content5: require('@/assets/images/active/snail/fifth/mo/zh/content5.png'),
            content6: require('@/assets/images/active/snail/fifth/mo/zh/content6.png'),
            content12: require('@/assets/images/active/snail/fifth/mo/zh/content12.png'),
            content13: require('@/assets/images/active/snail/fifth/mo/zh/content13.png'),
            save_text: require('@/assets/images/active/snail/fifth/mo/zh/save_text.png'),
            benefit: require('@/assets/images/active/snail/fifth/mo/benefit.png'),
            benefitLink: 'https://qcg.ink/bOFBl',
        },
        'zh-tw': {
            captions: `在逃多年的<span>英雄</span>罪犯蝸牛與黃鸝鳥落網，直播公審即將開啟！在逃多年的<span>英雄</span>罪犯蝸牛與黃鸝鳥落網，直播公審即將開啟！在逃多年的<span>英雄</span>罪犯蝸牛與黃鸝鳥落網，直播公審即將開啟！`,
            watch_btn: require('@/assets/images/active/snail/fifth/hk/btn_1.png'),
            slogan: require('@/assets/images/active/snail/fifth/hk/slogan.png'),
            open_btn: require('@/assets/images/active/snail/fifth/hk/open_btn.png'),
            details: require('@/assets/images/active/snail/fifth/hk/details.png'),
            brid_details: require('@/assets/images/active/snail/fifth/hk/brid_details.png'),
            dna: require('@/assets/images/active/snail/fifth/hk/dna.png'),
            self: require('@/assets/images/active/snail/fifth/hk/self.png'),
            brid_self: require('@/assets/images/active/snail/fifth/hk/brid_self.png'),
            native: require('@/assets/images/active/snail/fifth/hk/native.png'),
            brid_native: require('@/assets/images/active/snail/fifth/hk/brid_native.png'),
            union: require('@/assets/images/active/snail/fifth/hk/union.png'),
            envelope: require('@/assets/images/active/snail/fifth/hk/envelope.png'),
            device: require('@/assets/images/active/snail/fifth/hk/device.png'),
            evidence: require('@/assets/images/active/snail/fifth/hk/evidence.png'),
            evidence1: require('@/assets/images/active/snail/fifth/hk/evidence1.png'),
            evidence2: require('@/assets/images/active/snail/fifth/hk/evidence2.png'),
            evidence3: require('@/assets/images/active/snail/fifth/hk/evidence3.png'),
            evidence4: require('@/assets/images/active/snail/fifth/hk/evidence4.png'),
            evidence5: require('@/assets/images/active/snail/fifth/hk/evidence5.png'),
            evidence6: require('@/assets/images/active/snail/fifth/hk/evidence6.png'),
            rule: require('@/assets/images/active/snail/fifth/hk/rule.png'),
            criminal: require('@/assets/images/active/snail/fifth/hk/criminal.png'),
            criminal1: require('@/assets/images/active/snail/fifth/hk/1.png'),
            criminal2: require('@/assets/images/active/snail/fifth/hk/2.png'),
            criminal3: require('@/assets/images/active/snail/fifth/hk/3.png'),
            criminal4: require('@/assets/images/active/snail/fifth/hk/4.png'),
            criminal5: require('@/assets/images/active/snail/fifth/hk/5.png'),
            criminal6: require('@/assets/images/active/snail/fifth/hk/6.png'),
            criminal7: require('@/assets/images/active/snail/fifth/hk/7.png'),
            criminal8: require('@/assets/images/active/snail/fifth/hk/8.png'),
            testimony1: require('@/assets/images/active/snail/fifth/hk/testimony1.png'),
            testimony2: require('@/assets/images/active/snail/fifth/hk/testimony2.png'),
            testimony3: require('@/assets/images/active/snail/fifth/hk/testimony3.png'),
            testimony4: require('@/assets/images/active/snail/fifth/hk/testimony4.png'),
            testimony5: require('@/assets/images/active/snail/fifth/hk/testimony5.png'),
            testimony6: require('@/assets/images/active/snail/fifth/hk/testimony6.png'),
            testimony7: require('@/assets/images/active/snail/fifth/hk/testimony7.png'),
            testimony8: require('@/assets/images/active/snail/fifth/hk/testimony8.png'),
            wanted: require('@/assets/images/active/snail/fifth/hk/wanted.png'),
            wantedLow: require('@/assets/images/active/snail/fifth/hk/wantedLow.png'),
            event: require('@/assets/images/active/snail/fifth/hk/event.png'),
            eventLow: require('@/assets/images/active/snail/fifth/hk/eventLow.png'),
            again: require('@/assets/images/active/snail/fifth/hk/again.png'),
            share: require('@/assets/images/active/snail/fifth/hk/share.png'),
            shareLow: require('@/assets/images/active/snail/fifth/hk/wantedLow.png'),
            code: require('@/assets/images/active/snail/fifth/hk/code.png'),
            reward_title: require('@/assets/images/active/snail/fifth/hk/reward_title.png'),
            click: require('@/assets/images/active/snail/fifth/hk/click.png'),
            reward1: require('@/assets/images/active/snail/fifth/hk/reward1.png'),
            reward2: require('@/assets/images/active/snail/fifth/hk/reward2.png'),
            reward3: require('@/assets/images/active/snail/fifth/hk/reward3.png'),
            last_msg: require('@/assets/images/active/snail/fifth/hk/last_msg.png'),
            snail: require('@/assets/images/active/snail/fifth/mo/post_snail.png'),
            brid: require('@/assets/images/active/snail/fifth/mo/post_brid.png'),
            race1: require('@/assets/images/active/snail/fifth/hk/race1.png'),
            race2: require('@/assets/images/active/snail/fifth/hk/race2.png'),
            stamp: require('@/assets/images/active/snail/fifth/hk/stamp.png'),
            isLogin: '很抱歉，請先登錄',
            isRole: '很抱歉，請先選擇角色',
            copySuccess: '已成功複製分享連結',
            copyError: '複製失敗',
            content5: require('@/assets/images/active/snail/fifth/hk/content5.png'),
            content6: require('@/assets/images/active/snail/fifth/hk/content6.png'),
            content12: require('@/assets/images/active/snail/fifth/hk/content12.png'),
            content13: require('@/assets/images/active/snail/fifth/hk/content13.png'),
            save_text: require('@/assets/images/active/snail/fifth/hk/save_text.png'),
            benefit: require('@/assets/images/active/snail/fifth/mo/benefit.png'),
            benefitLink: 'https://h5.snell.com.tw/snail_5thSpecial/enter',
        }
    };

    constructor(lang = 'zh-cn', initialRole = '小蜗牛') {
        console.log('lang', lang)
        // 参数验证
        this.lang = TrialConfig.validateLanguage(lang);
        this.roleName = initialRole;
        this.translations = TrialConfig.TRANSLATIONS[this.lang];
        console.log('TrialConfig', this.lang, this.translations)
    }

    // 语言验证方法
    static validateLanguage(lang) {
        return Object.keys(TrialConfig.TRANSLATIONS).includes(lang)
            ? lang
            : 'zh-cn';
    }

    // 设置语言
    setLanguage(lang) {
        this.lang = TrialConfig.validateLanguage(lang);
    }

    // 获取当前配置
    get config() {
        return {
            currentLanguage: this.lang,
            currentRole: this.roleName,
            translations: this.translations
        };
    }
}
export class dynamicsConfig {
    // 静态资源定义
    static ASSETS = {
        snail_head: snail_head,
        forg_head: forg_head,
        earth_head: earth_head,
        brid_head: brid_head,
        msg_1: msg_1,
        msg_2: msg_2,
        msg_3: msg_3,
        msg_4: msg_4,
        msg_5: msg_5,
        msg_6: msg_6,
        msg_7: msg_7
    };
    static TRANSLATIONSTalk = {
        'zh-cn': {
            talk_1: {
                head: {
                    img: dynamicsConfig.ASSETS.forg_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_1,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'left',
                },
                content: '全体起立，请审判长入庭。',
                show: true
            },
            talk_2: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: '现在开庭，本案由本意志担任公诉人、审判长，呱呱担任陪审员、庭审书记。',
                show: true
            },
            talk_3: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: role => `传被告人${role}入庭，现在开始核对被告身份!`,
                show: true
            },
            talk_4: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `根据规定，你有权进行自辩环节。`,
                show: true
            },
            talk_5: {
                head: {
                    img: dynamicsConfig.ASSETS.snail_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_4,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'right',
                },
                content: `我申请自行辩护。`,
                show: true
            },
            talk_6: {
                head: {
                    img: dynamicsConfig.ASSETS.snail_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_4,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'right',
                },
                content: `我申请我的辩护律师出庭。`,
                show: true
            },
            talk_7: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_1,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'left',
                },
                content: `本庭准许被告自行辩护。`,
                show: true
            },
            talk_8: {
                head: {
                    img: dynamicsConfig.ASSETS.forg_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `被告辩护律师缺席，自个儿辩吧。`,
                show: true
            },
            talk_9: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_1,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'left',
                },
                content: `现在由本庭宣读起诉书！`,
                show: true
            },
            talk_10: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `本案除以上确凿罪行外，还有一些争议点。接下来将进行争议事件的抗辩阶段。`,
                show: true
            },
            talk_11: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `抗辩成功或许能从轻处罚，被告是否赞同进入抗辩环节？`,
                show: true
            },
            talk_12: {
                head: {
                    img: dynamicsConfig.ASSETS.snail_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_3,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'right',
                },
                content: `不抗辩，我承认所有对我的指控。`,
                show: true
            },
            talk_13: {
                head: {
                    img: dynamicsConfig.ASSETS.snail_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_4,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'right',
                },
                content: `申请抗辩，我是无辜的。`,
                show: true
            },
            talk_14: {
                head: {
                    img: dynamicsConfig.ASSETS.forg_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `呱呱：策划没有设计跳过功能，老实看完报告吧！`,
                show: true
            },
            talk_15: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `现在进入辩论阶段，书记员做好记录。原告、被告、代理人开始发表意见！`,
                show: true
            },
            talk_16: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `经议庭评议，被告犯罪行为多、性质重，情节恶劣....`,
                show: true
            },
            talk_17: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_1,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'left',
                },
                content: `将在原基础上从重判罚！`,
                show: true
            },
            talk_18: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `我将宣布，罪名成立！判决如下！`,
                show: true
            },
            question_1: {
                question: 4,
                answer: [{
                    content: 5,
                    display: '6,8'
                }, {
                    content: 6,
                    display: '5,7'
                }]
            },
            question_2: {
                question: 11,
                answer: [{
                    content: 12,
                    display: '13'
                }, {
                    content: 13,
                    display: '12,14'
                }]
            }
        },
        'zh-tw': {
            talk_1: {
                head: {
                    img: dynamicsConfig.ASSETS.forg_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_6,
                    style: { width: '6.05rem', height: '1rem' },
                    position: 'left',
                },
                content: '請全體起立，請審判長入庭。',
                show: true
            },
            talk_2: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: '現在開庭，本案由本意志擔任公訴人、審判長，呱呱擔任陪審員、庭審書記。',
                show: true
            },
            talk_3: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: role => `傳被告人${role}入庭，現在開始核對被告身份！`,
                show: true
            },
            talk_4: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `根據規定，你有權進行自行辯護。`,
                show: true
            },
            talk_5: {
                head: {
                    img: dynamicsConfig.ASSETS.snail_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_4,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'right',
                },
                content: `我申請自行辯護`,
                show: true
            },
            talk_6: {
                head: {
                    img: dynamicsConfig.ASSETS.snail_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_4,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'right',
                },
                content: `我申請我的辯護律師出庭。`,
                show: true
            },
            talk_7: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_1,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'left',
                },
                content: `本庭准許被告自行辯護。`,
                show: true
            },
            talk_8: {
                head: {
                    img: dynamicsConfig.ASSETS.forg_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `被告辯護律師缺席，自己辯吧。`,
                show: true
            },
            talk_9: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_1,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'left',
                },
                content: `現在由本庭宣讀起訴書！`,
                show: true
            },
            talk_10: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `本案除以上確鑿罪行外，還有一些爭議點。接下來將進行爭議事件的抗辯階段。`,
                show: true
            },
            talk_11: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `抗辯成功或許能從輕處罰，被告是否贊同進入抗辯環節？`,
                show: true
            },
            talk_12: {
                head: {
                    img: dynamicsConfig.ASSETS.snail_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_3,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'right',
                },
                content: `不抗辯，我承認所有對我的指控。`,
                show: true
            },
            talk_13: {
                head: {
                    img: dynamicsConfig.ASSETS.snail_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_4,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'right',
                },
                content: `申請抗辯，我是無辜的。`,
                show: true
            },
            talk_14: {
                head: {
                    img: dynamicsConfig.ASSETS.forg_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `呱呱：企劃沒有設計跳過功能，老實看完報告吧！`,
                show: true
            },
            talk_15: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `現在進入辯論階段，書記員做好記錄。原告、被告、代理人開始發表意見！`,
                show: true
            },
            talk_16: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `經議庭評議，被告犯罪行為多、性質重，情節惡劣...`,
                show: true
            },
            talk_17: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_1,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'left',
                },
                content: `將在原基礎上從重判罰！`,
                show: true
            },
            talk_18: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: `我宣佈，罪名成立！判決如下！`,
                show: true
            },
            question_1: {
                question: 4,
                answer: [{
                    content: 5,
                    display: '6,8'
                }, {
                    content: 6,
                    display: '5,7'
                }]
            },
            question_2: {
                question: 11,
                answer: [{
                    content: 12,
                    display: '13'
                }, {
                    content: 13,
                    display: '12,14'
                }]
            }
        }
    };
    static TRANSLATIONSTalkMini = {
        'zh-cn': {
            talk_1: {
                head: {
                    img: dynamicsConfig.ASSETS.forg_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_1,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'left',
                },
                content: '全体起立，请审判长入庭。',
                show: true
            },
            talk_2: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: '现在开庭，本案由本意志担任公诉人、审判长，呱呱担任陪审员、庭审书记。',
                show: true
            },
            talk_3: {
                head: {
                    img: dynamicsConfig.ASSETS.forg_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: '等等...这个被告人看起来眼生，确定没抓错人？',
                show: true
            },
            talk_4: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_1,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'left',
                },
                content: '档案记录看起来挺干净的',
                show: true
            },
            talk_5: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: '没事儿，不白来哈老弟，咱先将就判个无期徒刑~',
                show: true
            },

        },
        'zh-tw': {
            talk_1: {
                head: {
                    img: dynamicsConfig.ASSETS.forg_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: '請全體起立，請審判長入庭。',
                show: true
            },
            talk_2: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: '現在開庭，本案由本意志擔任公訴人、審判長，呱呱擔任陪審員、庭審書記。',
                show: true
            },
            talk_3: {
                head: {
                    img: dynamicsConfig.ASSETS.forg_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: '等等…這個被告人看起來很陌生，確定沒抓錯人？',
                show: true
            },
            talk_4: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_1,
                    style: { width: '5.09rem', height: '0.96rem' },
                    position: 'left',
                },
                content: '檔案記錄看起來挺乾淨的。',
                show: true
            },
            talk_5: {
                head: {
                    img: dynamicsConfig.ASSETS.earth_head,
                    style: { width: '1.2rem', height: '1.19rem' }
                },
                msg: {
                    img: dynamicsConfig.ASSETS.msg_2,
                    style: { width: '6.05rem', height: '1.73rem' },
                    position: 'left',
                },
                content: '沒事兒老弟，沒白跑啦～我先將就判個無期徒刑～',
                show: true
            },

        }
    }

    // 样式常量
    static STYLES = {
        leftPadding: '0.3rem 0rem 0rem 0.5rem',
        rightPadding: '0.4rem 0.2rem 0.1rem 0.4rem'
    };

    constructor(lang = 'en', params = {}) {
        console.log('dynamicsConfig constructor');
        // // 参数验证
        this.params = params
        this.lang = dynamicsConfig.validateLanguage(lang);
        if (params.score < 100000) {
            this.translationsTalk = dynamicsConfig.TRANSLATIONSTalkMini[this.lang]
            console.log('low', dynamicsConfig.TRANSLATIONSTalkMini[this.lang]);
        } else {
            this.translationsTalk = dynamicsConfig.TRANSLATIONSTalk[this.lang]
        }
        this.msglist = this.transformTalksToArray(this.translationsTalk, params);
        console.log('msglist', this.msglist);
        this.dynamicsContentDetails = this.dynamicsContent(params)[this.lang];
        console.log('dynamicsContentDetails', this.dynamicsContentDetails);
    }
    static convertTimestampToDaysHours(timestamp) {
        const days = Math.floor(timestamp / 86400);
        const hours = Math.floor((timestamp % 86400) / 3600);
        return `${days}天${hours}小时`;
    }
    // 语言验证方法
    static validateLanguage(lang) {
        return Object.keys(TrialConfig.TRANSLATIONS).includes(lang)
            ? lang
            : 'zh-cn';
    }
    dynamicsContent(params) {
        console.log('dynamicsContent', params);
        const unit = {
            'zh-cn': ['阶', '亿', '万', {
                angel: "天使",
                zombie: "活尸",
                machine: "机械",
                monster: "巨龙",
                alien: "异种",
                devil: "恶魔"
            }],
            'zh-tw': ['階', '亿', '万', {
                angel: "天使",
                zombie: "活屍",
                machine: "機械",
                monster: "巨龍",
                alien: "異種",
                devil: "惡魔"
            }],
        }
        function timestampToDays(timestamp) {
            // 转换时间戳为日期
            const pastDate = new Date(timestamp * 1000);
            const now = new Date();

            // 计算相差天数（含当日）
            const diffTime = now - pastDate;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            // 格式化日期输出
            const formatDate = pastDate.toLocaleString('zh-CN', {
                timeZone: 'Asia/Shanghai',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });

            return {
                originalDate: formatDate,
                daysFromNow: diffDays
            };
        }
        function getMaxTranslatedRandom(obj, translations) {
            if (obj.length < 1) {
                return '???'
            }

            const maxValue = Math.max(...Object.values(obj));
            const maxKeys = Object.keys(obj).filter(key => obj[key] === maxValue);
            // 优先返回monster，否则返回第一个最大值
            const resultKey = maxKeys.includes('monster') ? 'monster' : maxKeys[0];
            return `${translations[3][resultKey]} ${maxValue}${translations[0]}`;
        }
        function formatPower(num, unit) {
            if (num >= 100000000) {
                // 大于等于1亿，保留两位小数，转为亿单位
                return (num / 100000000).toFixed(2) + unit[1];
            } else {
                // 小于1亿，保留两位小数，转为万单位
                return (num / 10000).toFixed(2) + unit[2];
            }
        }
        function getPercentageByValue(value) {
            const ranges = [
                { min: 0, max: 20000, percent: 50 },
                { min: 20001, max: 40000, percent: 52 },
                { min: 40001, max: 60000, percent: 54 },
                { min: 60001, max: 80000, percent: 56 },
                { min: 80001, max: 100000, percent: 58 },
                { min: 100001, max: 200000, percent: 60 },
                { min: 200001, max: 400000, percent: 62 },
                { min: 400001, max: 600000, percent: 64 },
                { min: 600001, max: 800000, percent: 66 },
                { min: 800001, max: 1000000, percent: 68 },
                { min: 1000001, max: 2000000, percent: 70 },
                { min: 2000001, max: 4000000, percent: 72 },
                { min: 4000001, max: 6000000, percent: 74 },
                { min: 6000001, max: 8000000, percent: 76 },
                { min: 8000001, max: 10000000, percent: 78 },
                { min: 10000001, max: 20000000, percent: 80 },
                { min: 20000001, max: 40000000, percent: 82 },
                { min: 40000001, max: 60000000, percent: 84 },
                { min: 60000001, max: 80000000, percent: 86 },
                { min: 80000001, max: 100000000, percent: 88 },
                { min: 100000001, max: 200000000, percent: 90 },
                { min: 200000001, max: 400000000, percent: 92 },
                { min: 400000001, max: 600000000, percent: 94 },
                { min: 600000001, max: 800000000, percent: 96 },
                { min: 800000001, max: 1000000000, percent: 98 },
                { min: 1000000001, max: Infinity, percent: 100 }
            ];

            const matchedRange = ranges.find(range =>
                value >= range.min && value <= range.max
            );

            return matchedRange ? matchedRange.percent : 0;
        }
        function getOtherTranslation(params, lang) {
            if (params.dataLostSign) {
                const translationsFied = {
                    'zh-cn': [{ content: '档案很干净，但议庭一致认为你必定存在不法行为，先判10年监禁等待始调查。' }, { content: '5周年是蛤的版本，为了避免你作为主角抢风头，先酌情判个死刑吧。' }],
                    'zh-tw': [{ content: '檔案很乾淨，但議庭一致認為你必定存在不法行為，先判10年監禁等待呱呱調查。' }, { content: '5週年是呱呱的版本，為了避免你作為主角搶風頭，先酌情判個死刑吧。' }],
                }
                return translationsFied[lang]
            }
            const other_data = params.other_data;
            function processTimestamp(input) {
                // 保留原始格式
                const originalFormat = input;
                // 转换为分钟级时间戳
                const minuteStr = input.substring(0, 16);
                const dateObj = new Date(minuteStr.replace(/-/g, '/'));
                const timestamp = dateObj.getTime();

                return {
                    original: originalFormat,
                    minuteTimestamp: timestamp
                };
            }
            function getDayDiff(timestamp1, timestamp2) {
                const diff = Math.abs(timestamp1 - timestamp2);
                return Math.floor(diff / (24 * 60 * 60 * 1000));
            }
            const translations = {
                'zh-cn': {
                    data1: {
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/7.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony8.png'),
                        content: `被告24年8月下旬销声匿迹了一段时间，疑似去玩别家的游戏。`,
                    },
                    data2: {
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/7.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony8.png'),
                        content: '被告24年10月上旬销声匿迹了一段时间，疑似去玩别家的游戏。'
                    },
                    data3: {
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/3.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony10.png'),
                        content: '今年2.14情人节当天在线时长超过20小时'
                    },
                    data4: {
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/3.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony4.png'),
                        content: '25年2月14日情人节这天罪犯未登录游戏，疑似和对象出门过节'
                    },
                    data5: {
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/3.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony4.png'),
                        content: '24年8月10日七夕节这天罪犯未登录游戏，疑似和对象出门过节'
                    },
                    data6: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/4.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony5.png'),
                        content: `2024年10月1日~10月7日罪犯单笔最高充值了${item.total_amount}元，涉案金额巨大，行为值得鼓励`
                    }),
                    data7: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/4.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony5.png'),
                        content: `2025年1月24日~2月5日罪犯单笔最高充值了${item.total_amount}元，涉案金额巨大，行为值得鼓励`
                    }),
                    data8: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony1.png'),
                        content: `${item.time}罪犯完成了巨龙8阶的进阶仪式，历时${getDayDiff(new Date(item.time).getTime(), item.create_time * 1000)}天，对亲朋好友造成了巨大的震撼`
                    }),
                    data9: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony1.png'),
                        content: `${item.time}罪犯完成了巨龙9阶的进阶仪式，历时${getDayDiff(new Date(item.time).getTime(), item.create_time * 1000)}天，对亲朋好友造成了巨大的震撼`
                    }),
                    data9: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony1.png'),
                        content: `${item.time}罪犯完成了巨龙9阶的进阶仪式，历时${getDayDiff(new Date(item.time).getTime(), item.create_time * 1000)}天，对亲朋好友造成了巨大的震撼`
                    }),
                    data10: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony2.png'),
                        content: `${item.time}罪犯浪费大量物资，单日消耗白蝌蚪共计${item.total_amount}个，疑似进行不理智的报复性消费`
                    }),
                    data11: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony5.png'),
                        content: `${item.time}罪犯充值${item.total_amount}元，涉案金额巨大，行为值得鼓励`
                    }),
                    data12: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony11.png'),
                        content: `${item.time}罪犯浪费大量物资，单日消耗许愿币共计${item.total_amount}个，疑似虚荣心作祟冲击榜一`
                    }),
                    data13: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony9.png'),
                        content: `${item.time}罪犯浪费大量物资，单日消耗栴檀共计${item.total_amount}支，佛龛一度发出过热警告`
                    }),
                    data14: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/2.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony3.png'),
                        content: `罪犯目前战力${item.total_amount}，尚未完成点石成金，未用心体验游戏，通报批评。`
                    }),
                    data15: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/2.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony3.png'),
                        content: `罪犯目前战力${item.total_amount}，尚未捡取卫生纸，未用心体验游戏，通报批评。`
                    }),

                },
                'zh-tw': {
                    data1: {
                        titleImg: require('@/assets/images/active/snail/fifth/hk/7.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/hk/testimony8.png'),
                        content: `被告八月下旬銷聲匿跡了一段時間，疑似去玩別家的遊戲。`,
                    },
                    data2: {
                        titleImg: require('@/assets/images/active/snail/fifth/hk/7.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/hk/testimony8.png'),
                        content: '被告十月上旬銷聲匿跡了一段時間，疑似去玩別家的遊戲。'
                    },
                    data3: {
                        titleImg: require('@/assets/images/active/snail/fifth/hk/3.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony10.png'),
                        content: '今年2.14情人节当天在线时长超过20小时'
                    },
                    data4: {
                        titleImg: require('@/assets/images/active/snail/fifth/hk/3.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/hk/testimony4.png'),
                        content: '25年2月14日情人节這天罪犯未登入遊戲，疑似和對象出門過節'
                    },
                    data5: {
                        titleImg: require('@/assets/images/active/snail/fifth/hk/3.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/hk/testimony4.png'),
                        content: '24年8月10日七夕节這天罪犯未登入遊戲，疑似和對象出門過節'
                    },
                    data6: (money) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/hk/4.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/hk/testimony5.png'),
                        content: `2024年6月21日~7月12日罪犯儲值了${money}元，涉案金額巨大，行為值得鼓勵`
                    }),
                    data7: (money) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/hk/4.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/hk/testimony5.png'),
                        content: `2025年1月24日~2月5日罪犯儲值了${money}元，涉案金額巨大，行為值得鼓勵`
                    }),
                    data8: (params) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/hk/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/hk/testimony1.png'),
                        content: `${processTimestamp(params.time).original}罪犯完成了巨龙8阶的進階儀式，對親朋好友造成了巨大的震撼`
                    }),
                    data9: (params) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/hk/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/hk/testimony1.png'),
                        content: `${processTimestamp(params.time).original}罪犯完成了巨龙9阶的進階儀式，對親朋好友造成了巨大的震撼`
                    }),
                    data10: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/hk/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/hk/testimony2.png'),
                        content: `${item.time}罪犯浪費大量物資，單日消耗白蝌蚪共計${item.total_amount}個，疑似進行不理智的報復性消費`
                    }),
                    data11: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/hk/5.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony1.png'),
                        content: `${item.time}罪犯儲值了${item.total_amount}元，涉案金額巨大，行為值得鼓勵`
                    }),
                    data12: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/hk/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony11.png'),
                        content: `${item.time}罪犯浪費大量物資，單日消耗許願幣共計${item.total_amount}個，疑似虛榮心作祟拚排行榜第一名`
                    }),
                    data13: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/8.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony9.png'),
                        content: `${item.time}罪犯浪費大量物資，單日消耗檀香共計${item.total_amount}支，佛龕一度發出過熱警告`
                    }),
                    data14: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/2.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony3.png'),
                        content: `罪犯目前戰力${item.total_amount}，尚未完成点石成金，未用心體驗遊戲，通報批評。`
                    }),
                    data15: (item) => ({
                        titleImg: require('@/assets/images/active/snail/fifth/mo/zh/2.png'),
                        msgImg: require('@/assets/images/active/snail/fifth/mo/zh/testimony3.png'),
                        content: `罪犯目前戰力${item.total_amount}，尚未捡取卫生纸，未用心體驗遊戲，通報批評。`
                    }),
                },
            }

            const langMap = translations[lang]; // 取繁体中文配置
            const result = [];

            Object.keys(other_data).forEach(key => {
                const value = other_data[key];
                if (key === 'data3' && value.total_amount < 72000) {
                    return; // 小于20小时跳过
                }
                // 判断是否有值（非空数组 && 非空对象）
                if (
                    Array.isArray(value) && value.length === 0 ||
                    Object.prototype.toString.call(value) === '[object Object]' && Object.keys(value).length === 0
                ) {
                    return; // 空则跳过
                }

                // 对应语言配置存在 && 是函数（如 data6~data9），传参数调用
                if (typeof langMap[key] === 'function') {
                    const dateOnly = value.time.split(" ")[0]
                    value.time = dateOnly
                    value.create_time = params.create_time;
                    const mapped = langMap[key](value);
                    if (mapped) result.push(mapped);
                }

                // 静态对象，直接推入
                else if (langMap[key]) {
                    result.push(langMap[key]);
                }
            });



            return result;


        }
        function wantedCreatObj(params, lang) {
            let wantedObj = null
            if (params.total_score > 100000) {
                const obj = {
                    'zh-cn':
                        [{
                            img: require('@/assets/images/active/snail/fifth/mo/zh/wanted1.png'),
                            content: `捕获白蝌蚪${params.gem_total}只，黑蝌蚪${params.money_total * 100}只。`
                        },

                        {
                            img: require('@/assets/images/active/snail/fifth/mo/zh/wanted2.png'),
                            content: `累计消耗${params.lottery_count}张抽奖券，折合白蝌蚪价值${params.lottery_count * 300}`
                        },
                        {
                            img: require('@/assets/images/active/snail/fifth/mo/zh/wanted3.png'),
                            content: `消耗突变抗原${params.gene_variation_consume}只，解锁器官${params.real_organ_count}个`
                        },
                        {
                            img: require('@/assets/images/active/snail/fifth/mo/zh/wanted4.png'),
                            content: `收集启示之眼${params.horus_eye}个，收集亵渎之眼${params.profane_eye}个`
                        },
                        {
                            img: require('@/assets/images/active/snail/fifth/mo/zh/wanted5.png'),
                            content: `总供奉时长${dynamicsConfig.convertTimestampToDaysHours(params.sacrifice_total * 10)}`
                        },
                        {
                            img: require('@/assets/images/active/snail/fifth/mo/zh/wanted6.png'),
                            content: `击败使徒数量${params.boss_challenge}人,完胜使徒数量${params.boss_full_win}人`
                        },
                        ],
                    'zh-tw':
                        [{
                            img: require('@/assets/images/active/snail/fifth/hk/wanted1.png'),
                            content: `捕获白蝌蚪${params.gem_total}隻，黑蝌蚪${params.money_total * 100}隻。`
                        },

                        {
                            img: require('@/assets/images/active/snail/fifth/hk/wanted2.png'),
                            content: `消耗抽獎券${params.lottery_count}張。折合價值白蝌蚪${params.lottery_count * 300}個`
                        },
                        {
                            img: require('@/assets/images/active/snail/fifth/hk/wanted3.png'),
                            content: `消耗突變抗原${params.gene_variation_consume}隻,解鎖器官總數${params.real_organ_count}個`
                        },
                        {
                            img: require('@/assets/images/active/snail/fifth/hk/wanted4.png'),
                            content: `搜集啟示之眼${params.horus_eye}個,搜集褻瀆之眼${params.profane_eye}個`
                        },
                        {
                            img: require('@/assets/images/active/snail/fifth/hk/wanted5.png'),
                            content: `总供奉时长${dynamicsConfig.convertTimestampToDaysHours(params.sacrifice_total * 10)}`
                        },
                        {
                            img: require('@/assets/images/active/snail/fifth/hk/wanted6.png'),
                            content: `減擊敗使徒數量${params.boss_challenge}人,完勝使徒數量${params.boss_full_win}人`
                        },
                        ]
                }
                const randomIndex = Math.floor(Math.random() * 6);
                wantedObj = obj[lang][randomIndex]
            } else {
                const obj = {
                    'zh-cn': {
                        img: require('@/assets/images/active/snail/fifth/mo/zh/wanted7.png'),
                        content: `这人太干净了，没啥犯罪记录，但是宁可杀错不能放过！`
                    },
                    'zh-tw': {
                        img: require('@/assets/images/active/snail/fifth/hk/wanted7.png'),
                        content: `這人太乾淨了，沒什麼犯罪記錄，但是寧可錯殺不能放過！`
                    },
                }
                wantedObj = obj[lang]
            }
            return wantedObj
        }
        return {
            'zh-cn': {
                unionTitle: '团伙' + (params.partner_male + params.partner_female) + '人',
                unionText: params.partner_male + '男' + params.partner_female + '女',
                surpass: '赏金超' + getPercentageByValue(params.total_score) + '%的玩家',
                gem_total: params.gem_total + '只',
                money_total: params.money_total * 100 + '只',
                lottery_count: params.lottery_count,
                gene_variation_consume: (params.gene_variation_consume || 0) + '只',
                real_organ_count: params.real_organ_count + '个',
                horus_eye: params.horus_eye + '个',
                profane_eye: params.profane_eye + '个',
                boss_challenge: params.boss_challenge + '人',
                boss_full_win: params.boss_full_win + '人',
                score: formatPower(params.total_score, unit[this.lang]),
                dna: getMaxTranslatedRandom(params.body_level, unit[this.lang]),
                age: timestampToDays(params.create_time).daysFromNow + '天',
                otherData: getOtherTranslation(params, this.lang),
                form_step: params.form_step ? `${params.form_step}阶` : '???',
                wanted: wantedCreatObj(params, this.lang),
                gene_variation_consume: params.gene_variation_consume + '只',
                sacrifice_total: dynamicsConfig.convertTimestampToDaysHours(params.sacrifice_total * 10)
            },
            'zh-tw': {
                unionTitle: '小夥伴' + (params.partner_male + params.partner_female) + '人',
                unionText: params.partner_male + '男' + params.partner_female + '女',
                surpass: '赏金超' + getPercentageByValue(params.total_score) + '%的玩家',
                gem_total: params.gem_total + '隻',
                money_total: params.money_total * 100 + '隻',
                lottery_count: params.lottery_count,
                gene_variation_consume: (params.gene_variation_consume || 0) + '隻',
                real_organ_count: params.real_organ_count + '個',
                horus_eye: params.horus_eye + '個',
                profane_eye: params.profane_eye + '個',
                boss_challenge: params.boss_challenge + '個',
                boss_full_win: params.boss_full_win + '個',
                score: formatPower(params.total_score, unit[this.lang]),
                dna: getMaxTranslatedRandom(params.body_level, unit[this.lang]),
                age: timestampToDays(params.create_time).daysFromNow + '天',
                otherData: getOtherTranslation(params, this.lang),
                form_step: params.form_step ? `${params.form_step}階` : '???',
                wanted: wantedCreatObj(params, this.lang),
                gene_variation_consume: params.gene_variation_consume + '隻',
                sacrifice_total: dynamicsConfig.convertTimestampToDaysHours(params.sacrifice_total * 10)
            }
        }
    }
    // 更新消息列表
    updateMsglist(displayKey) {
        const displayArr = displayKey.split(',')
        displayArr.forEach((item, index) => {
            this.msglist[item - 1].msg.show = false
        })
        console.log(this.msglist)
    }
    updateStaic(translationFunc, newRole) {
        if (typeof translationFunc === 'function') {
            return translationFunc(newRole);
        }
        throw new Error('Invalid translation function');
    }
    // 构造对话列表
    transformTalksToArray(originalTalks, params) {
        const slef = params.race === 2 ? {
            img: dynamicsConfig.ASSETS.brid_head,
            style: { width: '1.2rem', height: '1.19rem' }
        } : {
            img: dynamicsConfig.ASSETS.snail_head,
            style: { width: '1.2rem', height: '1.19rem' }
        }
        const defaultRole = this.params.role_name;
        return Object.entries(originalTalks)
            .filter(([key]) => key.startsWith('talk_'))
            .map(([_, talk]) => ({
                head: talk.msg.position === 'left' ? talk.head : slef,
                msg: {
                    img: talk.msg.img,
                    style: { ...talk.msg.style },
                    contentStyle: {
                        padding: talk.msg.position === 'left' ? dynamicsConfig.STYLES.leftPadding : dynamicsConfig.STYLES.rightPadding,
                        ...talk.msg.style
                    },
                    left: talk.msg.position,
                    show: talk.show
                },
                content: typeof talk.content === 'function'
                    ? talk.content(defaultRole)
                    : talk.content,
                me: false
            }));
    }
    // 构造对话对象
    getQuestionContent(questionKey) {
        console.log(questionKey, 'questionKey')
        const question = `question_${questionKey}`
        const questionData = this.translationsTalk[question];
        const questionContent = [this.msglist[questionData.question - 1].content];
        const answers = [
            {
                content: TrialConfig.TRANSLATIONS[this.lang][`content${questionData.answer[0].content}`],
                display: questionData.answer[0].display,
                click: false
            },
            {
                content: TrialConfig.TRANSLATIONS[this.lang][`content${questionData.answer[1].content}`],
                display: questionData.answer[1].display,
                click: false
            }
        ]
        return {
            question: questionContent,
            answers: answers,
        };
    }
    // 设置语言
    setLanguage(lang) {
        this.lang = TrialConfig.validateLanguage(lang);
    }

    // 获取当前配置
    get config() {
        return {
            msglist: this.msglist,
            currentLanguage: this.lang,
            currentRole: this.roleName,
            ttranslationsTalk: this.translationsTalk
        };
    }
}




// WEBPACK FOOTER //
// ./src/pages/snail/5thReport/TrialConfig.js